export default "/kiban/_next/static/images/13_6L_1-4-1_withBH-8094ee0645a4cba671dcae2db2ee47a2.png";